import "./ComingSoon.css";

function ComingSoon() {
  return (
    <div className="coming-soon">
      <div className="coming-soon-content">
        <h1 className="coming-soon-brand">PowerGrip K9</h1>
        <p className="coming-soon-tagline">Premium Dog Training Equipment</p>
        <div className="coming-soon-divider" />
        <h2 className="coming-soon-headline">Coming Soon</h2>
        <p className="coming-soon-sub">
          We're putting the finishing touches on something great.
          <br />
          Check back soon for handcrafted tug toys built for elite working dogs.
        </p>
      </div>
    </div>
  );
}

export default ComingSoon;
